<template>
    <div class="d-inline-block">
        <div class="d-flex flex-row">
            <div ref="email" :class="{'strike': blacklisted}">
                <slot></slot>
            </div>
            <button @click="block"
                    :class="{'btn-outline-muted': blacklisted, 'btn-outline-danger': !blacklisted}"
                    class="btn btn-xs ml-2">
                <i class="fas fa-ban"></i>&nbsp;<span>{{ blacklisted ? 'Gesperrt' : 'Sperren' }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlacklistableEmail',

    props: {
        isBlacklisted: Boolean,
        suggestReason: String,
    },

    data() {
        return {
            blacklisted: false,
        };
    },

    mounted() {
        this.blacklisted = this.isBlacklisted;
    },

    methods: {
        async block() {
            if (this.blacklisted) {
                this.unblock();
                return;
            }

            let email = this.$refs.email.innerText;

            const {value: reason} = await Swal.fire({
                title: email + ' sperren',
                input: 'text',
                inputLabel: 'Eine kurze Begründung zur Sperrung',
                inputValue: this.suggestReason,
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Sie müssen eine Begründung angeben!';
                    }
                },
            });

            if (reason) {
                axios.post(this.$route('blacklist.email'), {
                    _token: this.$csrf_token(),
                    email: email,
                    reason: reason,
                }).then(response => {
                    this.blacklisted = true;
                    toastr.success(response.data);
                }).catch(error => {
                    toastr.warning(error.response.data);
                });
            }
        },

        unblock(){
            //TODO: ask for confirmation and unblacklist email
        }
    },
};
</script>

<style scoped>
.strike {
    text-decoration: line-through;
}
</style>
